import { useEffect, useState } from 'react';
import { useCustomer } from './useCustomer';

export default function useNewsletterUnsubscribe(): {
  initialValues: IniatialValuesType;
} {
  const { customer } = useCustomer();
  const [initialValues, setInitialValues] = useState<IniatialValuesType>(
    defaultValues
  );

  useEffect(() => {
    if (customer?.isLoggedIn) {
      const { email } = customer;
      setInitialValues({
        ...initialValues,
        email: email,
      });
    }
  }, [customer]);

  return {
    initialValues,
  };
}

const defaultValues = {
  turnstileToken: '',
  email: '',
  mailOption: false,
  smsOption: false,
  partOption: false,
};

export type IniatialValuesType = {
  turnstileToken: string;
  email: string;
  mailOption: boolean;
  smsOption: boolean;
  partOption: boolean;
};
